export const formatPrice = (amount, currency) => {
  const formatter = Intl.NumberFormat(Intl.NumberFormat().resolvedOptions().locale, {
    style: 'currency',
    currencyDisplay: currency === 'USD' ? 'narrowSymbol' : 'symbol',
    currency: currency,
    ...(Number.isInteger(amount)
      ? { minimumFractionDigits: 0, maximumFractionDigits: 0 }
      : {
        minimumFractionDigits: 1,
        maximumFractionDigits: 2,
      }),
  })

  return  formatter.format(amount)
}